export enum ScheduleType {
  DepartureTrip = 0,
  ReturnTrip = 1,
}
